"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiChargePayByIdDto = void 0;
const class_validator_1 = require("class-validator");
const billing_api_payment_intent_dto_1 = require("../../../billing-api-payment/types/dtos/billing-api-payment-intent.dto");
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
/**
 * Запрос на оплату начисления
 */
let BillingApiChargePayByIdDto = class BillingApiChargePayByIdDto extends billing_api_payment_intent_dto_1.BillingApiPaymentIntentAbstractDto {
  constructor() {
    super();
  }
};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id оплачиваемого начислений",
  format: "uuid",
  type: String,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiChargePayByIdDto.prototype, "chargeId", void 0);
BillingApiChargePayByIdDto = __decorate([(0, class_transformer_1.Exclude)(), __metadata("design:paramtypes", [])], BillingApiChargePayByIdDto);
exports.BillingApiChargePayByIdDto = BillingApiChargePayByIdDto;
